
        import 'Contact.8e80ef6.css-module'
        export default {"contact":"contact_Contact_8e80ef6","contactNameNumber":"contactNameNumber_Contact_8e80ef6","contactName":"contactName_Contact_8e80ef6","contactEmail":"contactEmail_Contact_8e80ef6"}
    